import React, { useEffect } from 'react';
import { MdReviews,MdOutlineQrCodeScanner,MdOutlineWidgets } from "react-icons/md";
import { FaUserCircle,FaRegStar } from "react-icons/fa";
import { FaRegCircleQuestion } from "react-icons/fa6";
import { SiAdguard } from "react-icons/si";
import { WiStars } from "react-icons/wi";
import { BsFillBookmarkStarFill,BsBarChartLineFill } from "react-icons/bs";
import Clients from './Clients';
import PageSection from './PageSection';
import Compliance from './Compliance';
import Booking from './Booking';
import Footer from './Footer';
import Branding from './Branding';

import first from '../../ReviewImage/firstsection.jpeg';
import second from '../../ReviewImage/secondsection.png';
import third from '../../ReviewImage/thirdsection.jpeg';
import plat from '../../ReviewImage/platform.png';
import build from '../../ReviewImage/builtrust.jpeg';
import ai from '../../ReviewImage/aireplies.jpeg';

import re from '../../ReviewImage/reviewanalysis.jpg';
import ca from '../../ReviewImage/competitoranalysis.jpg';

import qa from '../../ReviewImage/queries.jpg';
import { useNavigate } from 'react-router-dom';







function Review() {
    const navigate = useNavigate();


    const reviewOne = [
        {
            icon:<MdOutlineQrCodeScanner />,
            iconTitle: 'Review Collection Channels',
            title: 'Making it effortless to gather valuable feedback with more advance functionality',
            lines: [
                'Faster and easier for customers to leave reviews in real-time.',
                'Contactless experience enhances operational efficiency, customer satisfaction, and data-driven decision-making for businesses.',
                'Positive reviews will directly publish on platform, it will to improve your reputation.',
                'If you get negative review, It will collect on your Elyzian’s dashboard, this will help you to prevent more customers and gives you the opportunity to improve.'

            ],
            image: second,
        },
    ]

    const reviewTwo = [
        {
            icon:<WiStars />,
            image: ai,

            iconTitle: 'AI Powered by Elyzian',
            title: "Elyzian's AI capabilities are a powerful tool for responding to reviews",
            lines: [
                'Freedom to reply with various options : Smart Replies, Smart Response, or with AI based Automated Response.',
                'Identify and prioritize reviews that require attention.',
                'Customize your responses to reviews efficiently using AI, generating individualized replies with just a single click.'

            ]
        },
    ]
    const reviewThree = [
        {
            icon:<FaRegStar className='text-base' />,
            image: plat,

            iconTitle: 'Review Monitoring',
            title: "Monitor reviews over 100+ platforms",
            lines: [
                'Monitor numerous top review platforms through a unified dashboard and uphold a flawless reputation across all customer search platforms.'

            ]
        },
    ]

    const reviewFour = [
        {
            icon:<WiStars />,
            image: third,

            iconTitle: 'AI Powered by Elyzian',
            title: "Automate engagement with automate replies",
            lines: [
                'Faster response times: Automated replies can be sent immediately after a review is posted, even outside of business hours.',
                'Increased customer satisfaction: Customers are more likely to be satisfied with a brand that responds to their feedback quickly and efficiently.',
                'Reduced workload for customer service teams.',
                'Freedom to reply with various options : Template Based, AI-Based.'

            ]
        },
    ]

    const reviewFive = [
        {
            icon:<MdOutlineWidgets />,
            iconTitle: 'Review Widgets',
            image: build ,
            title: "Build trust with website visitors",
            lines: [
                'Increased conversion rates: Studies have shown that displaying customer reviews on your website can increase conversion rates by up to 270%.',
                'When potential customers see that you have a lot of positive reviews, they are more likely to view your brand as trustworthy and reliable.',
                

            ]
        },
    ]

    const reviewSix = [
        {
            icon:<FaRegStar className='text-base' />,
            image: re ,
            iconTitle: 'Review Analysis',
            title: "Collect and analyse customer reviews to identify trends, patterns, and insights",
            lines: [
                'Businesses understand what their customers like and dislike about their products and services.',
                'Businesses identify areas where they need to improve their customer service (Pain Points).',
                'Boost sales and conversions and Protect against negative reviews.'
                

            ]
        },
    ]
    const reviewSeven = [
        {
            icon:<FaRegCircleQuestion />,
            iconTitle: 'Queries',
            image: qa ,

            title: "Read and reply all your business queries from a single inbox",
            lines: [
                'Use feedback to enhance products, pinpoint areas for improvement, and gain deeper insights into customer needs.',
                'Attract new customers and encourage them to learn more about your business.',
                'Increase your brand awareness and attract new customers.'
                

            ]
        },
    ]

    const reviewEight = [
        {
            icon:<BsBarChartLineFill />,
            iconTitle: 'Competitor Analysis',
            image: ca ,

            title: 'Making it effortless to gather valuable feedback with more advance functionality',
            lines: [
                'Compare external feedback with your own reviews to pinpoint strengths and areas for improvement.',
                'Customer reviews can also reveal areas where your competitors are not meeting customer needs.',
                'Understanding what customers are saying about your competitors.',
                'Regular competitor reviews help gauge your progress and measure your standing against rivals over time.',
                'Gain insights from competitor feedback to make smarter business decisions.'

            ]
        },
    ]
    const reviewCard = [{
        icon:<FaUserCircle />,
        title: 'Take steps to retain potential customers and prevent losing them',
        sub: 'Customer reviews significantly impact purchase decisions. Mishandling negatives repels potential customers; positive reviews amplify your brand, attract prospects, and improve conversions.',

    },
    {
        icon:<SiAdguard />,
        title: 'Customer Trust and Confidence',
        sub: 'Potential customers often rely on online reviews to make purchasing decisions. Positive reviews act as social proof, instilling confidence in the brand and its products or services.',

    },
    {
        icon:<BsFillBookmarkStarFill />,
        title: 'Handle criticism before it becomes a crisis',
        sub: "Monitoring and managing online reviews allow businesses to address potential crises promptly. Addressing negative reviews professionally can help mitigate the impact on the brand's reputation.",

    },]

  return (
    <div className='pt-5  gap-[70px] flex flex-col items-center min-h-full w-full'>
        <div className='w-full flex justify-center bg-white sticky top-0 pt-5'>
            <div   className={` w-[78%]   flex  bg-white  pb-4 `}>    
                <div className='flex gap-2 items-center'>
                    <div>
                    <MdReviews className='text-[30px] text-blue-600' />
                    </div>
                    <div className='flex flex-col'>
                        <span className='semibold text-[13px]'>Elyzian</span>
                        <span className='bold text-sm'>Review Management</span>

                    </div>
                </div>
            </div>
      </div>

      {/* 1st Section */}

      <div  className="w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] h-max lg:h-[620px] sm:mt-3  flex flex-col lg:flex-row gap-6 lg:gap-3   p-[5%] bg-[#fafafa] sm:rounded-[50px]">       
         <div className='w-full lg:w-[50%] flex flex-col gap-5 justify-start h-full'>
            <div>     
            <span className='bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px]'>More reviews,<br /> More businesss</span>    
</div>
           
            <span className='regular  text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px]  '>Enhancing a business's reputation, customer relationships, and decision-making processes. By leveraging the power of customer feedback and positive reviews, businesses can drive revenue growth and achieve long-term success.
            </span>
            
                
                <button onClick={() => navigate('/waitlist')} className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
  <span className="button-content medium">Get Started Free</span>
</button>
         </div>
         <div className=' w-full lg:w-[50%]'>
         <img className='xl:h-[500px] aspect-auto' src={first} alt="" />

         </div>
      </div>

      {/* 2nd Section */}
            <Clients />

            {/* 3rd Section */}
            <div  className="w-[90%] lg:w-[85%] 2xl:w-[78%] flex flex-col gap-10 mt-24 items-center">       
    <span className='bold text-center  text-[20px] sm:text-[24px] lg:text-[30px]'>Why does online review management matter?</span>
    <div className=' flex flex-wrap xl:flex-nowrap gap-4 justify-evenly w-full'>
     {reviewCard?.map((e) => (
        <div className="w-[380px] h-[400px] border rounded-[30px] shadow-md bg-[#fafafa] flex flex-col gap-5 p-6">
        <span className="text-2xl xl:text-3xl 2xl:text-5xl text-blue-700"> {e.icon}</span>
        <span className='bold text-[17px] xl:text-[20px]  '>{e.title}</span>    
            
             <span className='regular text-sm lg:text-base leading-[25px] lg:leading-[30px] break-words  '>{e.sub}</span>
        </div>
     ))}
       

    </div>
  </div>
      {/* 4th Section */}
      <PageSection bg  data={reviewOne} />

      <PageSection reverse  data={reviewTwo} />
    
      <PageSection   data={reviewThree} />

      <PageSection bg  data={reviewFour} />
      {/* <Clients /> */}

      <PageSection reverse  data={reviewFive} />

      <PageSection bg data={reviewSix} />

      <PageSection  data={reviewSeven} />

      <Branding />

      <PageSection bg reverse data={reviewEight} />

      <Compliance />

      <Booking />

      <Footer />





    </div>
  )
}

export default Review
